import { Helmet } from "react-helmet-async";

function Contact() {
    return (
        <main className="contact-page">
            <Helmet>
                <title>Contact | Cris Gym Fitness</title>
                <meta
                    name="description"
                    content="Contacteaza Cris Gym Fitness pentru detalii despre abonamente, program si locatie. Te asteptam la sala."
                />
            </Helmet>
            <section className="contact-page-hero">
                <div className="contact-page-container">
                    <p className="contact-page-label">Contact</p>
                    <h1 className="contact-page-title">Hai sa ne vedem la sala</h1>
                    <p className="contact-page-subtitle">
                        Vino sa te antrenezi intr-un mediu curat, organizat si prietenos.
                        Te asteptam!
                    </p>
                </div>
            </section>

            <section className="contact-page-content">
                <div className="contact-page-container">
                    <div className="contact-grid">

                        {/* LEFT - INFO */}
                        <div className="contact-info-card">
                            <h2>Informatii de contact</h2>

                            <div className="contact-item">
                                <span>📍 Adresa</span>
                                <p>Bulevardul Iuliu Maniu 140-142, București</p>
                            </div>

                            <div className="contact-item">
                                <span>📞 Telefon</span>
                                <a href="tel:+40722610468" className="contact-phone">
                                    0722 610 468
                                </a>
                            </div>

                            <div className="contact-item">
                                <span>🕒 Program</span>
                                <p>
                                    Luni - Vineri: 07:00 - 23:00 <br />
                                    Sambata: 09:00 - 18:00 <br />
                                    Duminica: 09:00 - 18:00
                                </p>
                            </div>
                        </div>

                        {/* RIGHT - MAP */}
                        <div className="contact-map-card">
                            <iframe
                                title="Google Maps"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2848.9088561177177!2d26.020183399999997!3d44.4350318!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40b201ae7d7e2dad%3A0x21bf7b60598ab133!2sCris%20Gym%20Fitness!5e0!3m2!1sro!2sro!4v1775847092739!5m2!1sro!2sro"
                                loading="lazy"
                                className="contact-map"
                            ></iframe>
                        </div>

                    </div>
                </div>
            </section>

            <section className="contact-page-cta">
                <div className="contact-page-container">
                    <h2 className="contact-cta-title">
                        Pregatit sa incepi?
                    </h2>
                    <p className="contact-cta-text">
                        Vino direct la sala sau suna-ne pentru detalii despre abonamente.
                    </p>
                </div>
            </section>
        </main>
    );
}

export default Contact;